import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import { useEffect, useState } from 'react';
import { RetrieveKey, SetUpIntent } from '../../Utils/StripeUtils';
import PaymentMethod from './PaymentMehtod';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.


export default function PaymentMethodElement({onChange, setStripe, setElements, getNewIntent, language='en'}) {
  const [stripePromise, setStripePromise] = useState()
  const [clientSecret, setClientSecret] = useState()
  const [randomKey, setRandomKey] = useState(Math.floor(Math.random()*10))
  useEffect(()=>{
    RetrieveKey()
    .then(key=>{
        setStripePromise(loadStripe(key))
    })
    .catch((e)=>console.log(e))
  }, [])
  useEffect(()=>{
    SetUpIntent()
    .then(secret=>{
      setClientSecret(secret)
      setRandomKey(randomKey+1)
    })
    .catch((e)=>console.log(e))
  }, [getNewIntent])
  return (
  <>
    {stripePromise && clientSecret&&(
      <Elements onChange={e=>console.log(e)} key={randomKey} stripe={stripePromise} options={{clientSecret, locale:language, paymentMethodCreation: 'manual'}}>
      <PaymentMethod onChange={e=>onChange(e)} setElements={(e)=>setElements(e)} setStripe={(e)=>setStripe(e)}  />
      </Elements>
    )
    }
  </>
    
  );
};